import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'edge_hill_text_block',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function defaultModuleData() {
            let bodyContent = '';
            if (props.d.title) {
                bodyContent += '<h2>' + props.d.title + '</h2>';
            }
            if (props.d.content) {
                bodyContent += props.d.content;
            }
            return {
                body: bodyContent
            };
        }
        return (_ctx, _cache) => {
            const _component_default = _resolveComponent("default");
            return (_openBlock(), _createBlock(_component_default, {
                d: defaultModuleData()
            }, null, 8, ["d"]));
        };
    }
});
